/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class DentalServiceRoute extends Route {
  // Services
  @service
  store;

  // State
  year = moment().format('YYYY');

  model() {
    let statuses = JSON.stringify([
      EnrolmentStatus.CURRENT,
      EnrolmentStatus.PENDING,
    ]);
    return hash({
      // TODO: Implement back-end enrolment entryDate range filtering.
      people: this.store.query('person', {
        type: PersonType.LEARNER,
        statuses,
        include: 'enrolments',
      }),
      caregivers: this.store.query('person', { type: PersonType.CAREGIVER }),
    });
  }
}
